/* eslint react/forbid-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { SubscriptionBlocks, PaymentMethodsLogos, SubscriptionCoupon } from '../../components/payments';

const SubscriptionTermsContainer = (props) => {
  const { type, terms, active } = props;

  return (
    <div className="paymentPeriod-container-wrapper">
      <SubscriptionBlocks
        termsData={terms}
        chosenOption={active}
      />
      <div className={`paymentFooter${type === 'subscription_other' ? ' paymentFooter--gift' : ''}`}>
        <PaymentMethodsLogos
          termsData={terms}
          active={active}
        />
        <div className="paymentCouponCodeInput ptm prm plm tar">
          {get(globals, 'currentDomainName') === 'otrapuse.lv' && (
            <div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/static/distances_ligums_OP_15102018.pdf"
                className="dib tar bdn tcb twb mbxs"
              >
                {get(translations, 'txt: Distances līgums', 'Distances līgums')}
              </a>
            </div>
          )}
          <SubscriptionCoupon
            active={active}
          />
        </div>
      </div>
    </div>
  );
};

SubscriptionTermsContainer.propTypes = {
  type: PropTypes.string.isRequired,
  terms: PropTypes.instanceOf(Object).isRequired,
  active: PropTypes.string,
};
SubscriptionTermsContainer.defaultProps = {
  active: null,
};

export default SubscriptionTermsContainer;
